function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { Text } from "../../Typography";
import RadioDotIcon from './RadioDotIcon';
import styles from './RadioDot.scss';

var RadioDot = function RadioDot(_ref) {
  var isChecked = _ref.isChecked,
      _onChange = _ref.onChange,
      children = _ref.children,
      className = _ref.className,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: value,
    className: classnames(styles.RadioDot, className)
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.nativeRadio,
    id: value,
    type: "radio",
    value: value,
    checked: isChecked,
    onChange: function onChange() {
      return _onChange(value);
    }
  }), /*#__PURE__*/React.createElement(RadioDotIcon, {
    className: classnames(styles.icon, _defineProperty({}, styles.iconActive, isChecked))
  }), children && /*#__PURE__*/React.createElement(Text, {
    tag: "span"
  }, children));
};

export default RadioDot;